<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div v-if="isOpen">
    <div :class="[bem(''), { active: isOpen }]">
      <div :class="bem('header')">
        <button :class="bem('header-close')" @click="close()">
          <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="m1 1 10.5 10.5m0-10.5L1 11.5"
              stroke="#000"
              stroke-width="2"
              stroke-linecap="round" />
          </svg>
        </button>
        <span
          :class="bem('header-title')"
          v-text="
            content === 'stock' ? locales.checkInStore : locales.sizeGuide
          "></span>

        <div
          v-if="content === 'stock' && locales.message !== ''"
          :class="bem('header-stock-message')">
          <span>{{ locales.message }}</span>
        </div>

        <!-- 
        <div v-if="content === 'stock'" :class="bem('header-product-title')">
          <span>{{ getProductTitle() }}</span>
        </div>
        -->

        <!-- Region Dropdown Selector -->
        <div v-if="content === 'stock'" :class="bem('header-region-selector')">
          <button
            :class="[
              bem('header-region-selector-button'),
              { active: showRegionDropdown },
            ]"
            @click="toggleRegionDropdown()">
            <span :class="bem('header-region-selector-label')">Region</span>
            <span>{{ activeRegion.name || 'Select Region' }}</span>
            <svg
              :class="[
                bem('header-region-selector-arrow'),
                { active: showRegionDropdown },
              ]"
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.382812 0.383016L5.79948 5.79968L11.2161 0.383016"
                stroke="#1D1D1D"
                stroke-width="1.08333" />
            </svg>
          </button>
          <div
            v-if="showRegionDropdown"
            :class="bem('header-region-selector-dropdown')">
            <div
              v-for="region in regions"
              v-if="region.name != activeRegion.name"
              :key="region.name"
              :class="[
                bem('header-region-selector-option'),
                { active: activeRegion.name === region.name },
              ]"
              @click="filterRegions(region.name)">
              {{ region.name }}
            </div>
          </div>
        </div>

        <div v-if="content === 'stock'" :class="bem('header-legend')">
          <div :class="bem('header-legend-item')">
            <span
              :class="[bem('header-legend-item-status'), 'in-stock']"></span>
            <span>{{ locales.inStockText || 'In Stock' }}</span>
          </div>
          <div :class="bem('header-legend-item')">
            <span
              :class="[bem('header-legend-item-status'), 'nearly-gone']"></span>
            <span>{{ locales.lowStockText || 'Low Stock' }}</span>
          </div>
          <div :class="bem('header-legend-item')">
            <span
              :class="[
                bem('header-legend-item-status'),
                'out-of-stock',
              ]"></span>
            <span>{{ locales.outOfStockText || 'Out of Stock' }}</span>
          </div>
        </div>
      </div>

      <div v-if="isLoading" :class="bem('loading')">Loading...</div>

      <div v-else :class="bem('content')">
        <div v-if="content === 'stock'" :class="bem('content-stock')">
          <div :class="bem('content-stock-table')">
            <div :class="bem('table-header')">
              <div :class="bem('header-cell')">Size</div>
              <div
                v-for="item in inventory"
                :key="item.id"
                :class="bem('header-cell')">
                {{ getVariantTitle(item.id) }}
              </div>
            </div>
            <div :class="bem('table-body')">
              <div
                v-for="outlet in activeRegion.outlets"
                :key="outlet.id"
                :class="bem('table-row')">
                <div :class="bem('table-row-container')">
                  <div :class="bem('table-cell', 'store')">
                    <div :class="bem('outlet')">
                      <span :class="bem('outlet-name')">
                        {{ outlet.displayName }}
                      </span>
                      <div :class="bem('outlet-details')">
                        <a
                          v-bind:href="`tel:${outlet.phone}`"
                          :class="bem('outlet-phone')">
                          <svg
                            width="13"
                            height="14"
                            viewBox="0 0 13 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M2 4.30769C2 8.55604 5.44396 12 9.69231 12H10.8462C11.4834 12 12 11.4834 12 10.8462V10.1428C12 9.87802 11.8198 9.64726 11.563 9.58306L9.2947 9.01598C9.06951 8.95969 8.83251 9.04383 8.69324 9.22953L8.19569 9.89292C8.05129 10.0855 7.80154 10.1706 7.57556 10.0878C5.87969 9.46659 4.53341 8.12031 3.91219 6.42444C3.8294 6.19846 3.91454 5.94871 4.10708 5.80431L4.77047 5.30676C4.95617 5.16749 5.04031 4.93049 4.98402 4.7053L4.41694 2.437C4.35274 2.18017 4.12198 2 3.85724 2H3.15385C2.51659 2 2 2.51659 2 3.15385V4.30769Z"
                              stroke="#0F172A"
                              stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                          <span>Call Store</span>
                        </a>
                        <button
                          :class="[
                            bem('outlet-toggle'),
                            { active: isOutletExpanded(outlet.id) },
                          ]"
                          @click="showOutletInfo(outlet.id)">
                          <span
                            v-text="
                              isOutletExpanded(outlet.id)
                                ? 'Close'
                                : 'Store Info'
                            "></span>
                          <svg
                            width="9"
                            height="10"
                            viewBox="0 0 9 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M5 4.16016H9V5.16016H5V9.16016H4V5.16016H0V4.16016H4V0.160156H5V4.16016Z"
                              fill="#141414" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="item in inventory"
                    :key="item.id"
                    :class="[
                      bem('table-cell'),
                      getQuantityClass(item.quantities, outlet.id),
                    ]"></div>
                </div>
                <div
                  v-show="isOutletExpanded(outlet.id)"
                  :class="bem('outlet-info-row')">
                  <div :class="bem('outlet-info')">
                    <div :class="bem('outlet-address')">
                      <div v-html="outlet.address"></div>
                    </div>
                    <div :class="bem('outlet-hours')">
                      <div v-html="outlet.hours"></div>
                    </div>
                    <div :class="bem('outlet-page')">
                      <a
                        v-bind:href="`/pages/${outlet.handle}`"
                        v-text="'View Directions'"
                        target="_blank"></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="bem('content-sizing')" v-if="content === 'sizing'">
          <div v-html="guide"></div>
        </div>
      </div>
      <div :class="bem('footer')">
        <div
          :class="[
            bem('footer-chat-wrapper'),
            { noMargin: countryCode == 'NZ' },
          ]">
          <a
            onclick="GorgiasChat.open();"
            target="_blank"
            :class="[bem('footer-chat'), 'btn']">
            Chat With Us
          </a>
        </div>
        <div v-if="showCheckInStoreButton" :class="bem('footer-toggle')">
          <button
            v-if="showCheckInStoreButton"
            :class="{ active: content === 'stock' }"
            @click="content = 'stock'">
            Check In Store
          </button>
          <button
            :class="{ active: content === 'sizing' }"
            @click="content = 'sizing'">
            Size Guide
          </button>
        </div>
      </div>
    </div>

    <div
      class="drawer-overlay"
      :class="{ active: isOpen }"
      @click="close()"></div>
  </div>
</template>

<script>
import { emitter } from '../../utils/mitt';

export default {
  name: 'Inventory',

  props: ['pid', 'product', 'guide', 'locales', 'countryCode'],

  data() {
    const isGift =
      this.product &&
      Array.isArray(this.product.tags) &&
      this.product.tags.some((t) => t.toLowerCase() === 'gift card');

    return {
      isOpen: false,
      isLoading: this.countryCode === 'NZ' && !isGift, // Only load if NZ and not a gift card
      // default to stock for NZ items unless gift card, otherwise sizing
      content: this.countryCode === 'NZ' && !isGift ? 'stock' : 'sizing',
      inventory: [],
      outlets: [],
      storeDetails: [],
      regions: [],
      activeRegion: '',
      showRegionDropdown: false,
      expandedOutlets: {}, // Track which outlets are expanded
    };
  },

  computed: {
    sortedOutlets() {
      return this.outlets
        .filter((outlet) => outlet.isShow)
        .sort((a, b) => a.weight - b.weight);
    },
    isNZ() {
      return this.countryCode === 'NZ';
    },
    isGiftCard() {
      return (
        this.product &&
        Array.isArray(this.product.tags) &&
        this.product.tags.some((t) => t.toLowerCase() === 'gift card')
      );
    },
    showCheckInStoreButton() {
      // only show the stock button when NZ and not a gift card
      return this.isNZ && !this.isGiftCard;
    },
  },

  created() {
    emitter.on('open:drawer', (content) => {
      this.isOpen = true;
      // Only allow 'stock' content if country is NZ and not a gift card,
      // otherwise default to 'sizing'.
      const allowStock = this.isNZ && !this.isGiftCard;
      this.content = content === 'stock' && !allowStock ? 'sizing' : content;
      if (document.querySelector('iframe#chat-button')) {
        document
          .querySelector('iframe#chat-button')
          .classList.add('hide-mobile');
      }
    });

    emitter.on('close:drawer', () => {
      this.isOpen = false;
      if (document.querySelector('iframe#chat-button')) {
        document
          .querySelector('iframe#chat-button')
          .classList.remove('hide-mobile');
      }
    });

    // Only fetch inventory data if country is NZ and not a gift card
    if (this.isNZ && !this.isGiftCard) {
      this.buildStoreList();

      const inventoryUrl = `/a/ps/vend/product/${this.pid}`;
      const outletsUrl = '/a/ps/vend/outlets';

      Promise.all([
        fetch(inventoryUrl).then((response) => response.json()),
        fetch(outletsUrl).then((response) => response.json()),
      ]).then(([inventoryData, outletsData]) => {
        this.inventory = inventoryData.data;
        this.outlets = outletsData.data;
        this.isLoading = false;
        this.outlets.forEach((outlet) => {
          const storeLocation = this.storeDetails.find(
            (store) => store.name == outlet.displayName
          );
          if (storeLocation != undefined) {
            outlet.handle = storeLocation.handle;
            outlet.phone = storeLocation.phone;
            outlet.address = storeLocation.address;
            outlet.hours = storeLocation.hours;
            outlet.region = storeLocation.region;
          }
        });
        this.buildRegionList();
        [this.activeRegion] = this.regions;
      });
    }
  },

  methods: {
    toggleRegionDropdown() {
      this.showRegionDropdown = !this.showRegionDropdown;
    },

    buildStoreList() {
      document
        .querySelector('#storeDetails')
        .querySelectorAll('.store')
        .forEach((store) => {
          this.storeDetails.push({
            name: store.dataset.name,
            phone: store.dataset.phone,
            address: store.dataset.address,
            hours: store.dataset.hours,
            handle: store.dataset.handle,
            region: store.dataset.region,
          });
        });
    },

    buildRegionList() {
      this.outlets.forEach((outlet) => {
        if (outlet.region !== '') {
          // Check if region already exists in regions array
          const existingRegion = this.regions.find(
            (region) =>
              region.name === outlet.region ||
              (outlet.region == undefined && region.name === 'Other')
          );

          console.log('existingRegion: ', existingRegion);

          if (existingRegion) {
            // Region exists, add location to existing region's locations array
            existingRegion.outlets.push(outlet);
          } else {
            // Region doesn't exist, create new region entry
            // eslint-disable-next-line no-lonely-if
            if (outlet.region == undefined) {
              this.regions.push({
                name: 'Other',
                outlets: [outlet],
              });
            } else {
              this.regions.push({
                name: outlet.region,
                outlets: [outlet],
              });
            }
          }
        }
      });
      console.log(this.regions);
      this.regions.sort((a, b) => a.name.localeCompare(b.name));
    },

    filterRegions(name) {
      [this.activeRegion] = this.regions.filter(
        (region) => region.name == name
      );
      this.showRegionDropdown = false;
    },

    showOutletInfo(id) {
      // Use Vue.set to ensure reactivity for the expandedOutlets object
      this.$set(this.expandedOutlets, id, !this.expandedOutlets[id]);
    },

    isOutletExpanded(id) {
      return this.expandedOutlets && this.expandedOutlets[id] === true;
    },

    bem(element, modifier, outputElement = false) {
      const blockClass = 'inventory';
      const elementClass = `${blockClass}__${element}`;
      const elementModifierClass = `${elementClass}--${modifier}`;

      if (element && modifier && outputElement) {
        return `${elementClass} ${elementModifierClass}`;
      }
      if (element && modifier && !outputElement) {
        return elementModifierClass;
      }
      if (element && !modifier) {
        return elementClass;
      }
      return blockClass;
    },

    getQuantityClass(quantities, outletId) {
      const quantity = quantities.find((qty) => qty.outlet_id === outletId);
      return quantity ? quantity.qty.toLowerCase().replace(/\s+/g, '-') : '';
    },

    getVariantTitle(vid) {
      const sizeIndex = this.product.options.findIndex(
        (option) => option === 'Size'
      );
      const optionKey = `option${sizeIndex + 1}`;
      return (
        this.product.variants.find((v) => v.id === Number(vid))?.[optionKey] ||
        ''
      );
    },

    getProductTitle() {
      return this.product.title;
    },

    close() {
      emitter.emit('close:drawer');
    },
  },
};
</script>

<style>
@media screen and (max-width: 64em) {
  .hide-mobile {
    display: none !important;
  }
}
</style>

<style lang="scss" scoped>
.inventory {
  width: 100%;
  max-width: 100vw;
  height: 100dvh;
  padding: 0;
  position: fixed;
  top: 0;
  right: -100vw;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  z-index: 100000;
  transition: right 0.3s ease;

  @media screen and (min-width: 64em) {
    max-width: 45vw;
    padding: 0;
    right: -45vw;
  }

  &.active {
    right: 0;
  }

  &__header {
    flex: 0 0 auto;
    padding: 2.5rem 0 0;

    &-close {
      position: absolute;
      top: 1.25rem;
      right: 1.25rem;
      padding: 0.75rem;
      background: transparent;
      border: none;
    }

    &-title {
      display: block;
      text-align: center;
      text-transform: uppercase;
      font-size: 1.25rem;
      font-weight: 400;
      letter-spacing: 0.04rem;
      color: #1d1d1d;

      @media screen and (min-width: 64em) {
        font-size: 2rem;
      }
    }

    &-stock-message {
      display: block;
      text-align: center;
      font-size: 0.75rem;
      font-weight: 400;
      letter-spacing: 0.04rem;
      color: #1d1d1d;
      margin: 0.75rem 2.5rem 0;
    }

    &-product-title {
      display: block;
      text-align: center;
      font-size: 1rem;
      font-weight: 400;
      letter-spacing: 0.04rem;
      color: #1d1d1d;
      margin: 0.75rem 2.5rem 0;
    }

    &-legend {
      margin-block: 1.5rem 2rem;
      display: flex;
      gap: 2rem;
      justify-content: center;

      &-item {
        display: flex;
        gap: 0.5rem;
        align-items: center;

        &-status {
          width: 1rem;
          height: 1rem;
          display: block;
        }
      }
    }

    &-region-selector {
      position: relative;
      margin: 1rem 2.5rem;

      &-label {
        font-size: 0.625rem;
        position: absolute;
        top: 0.25rem;
        color: #a1a1a1;
      }

      &-button {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 0.75rem 0.5rem;
        background: #ffffff;
        border: 1px solid #000000;
        font-size: 0.875rem;
        color: #000000;
        cursor: pointer;
        transition: all 0.2s ease;

        &.active {
          border-bottom: none;
        }
      }

      &-arrow {
        transition: transform 0.2s ease;

        &.active {
          transform: rotate(180deg);
        }
      }

      &-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: #fff;
        border: 1px solid #000000;
        border-top: none;
        z-index: 10;
        max-height: 200px;
        overflow-y: auto;
        padding-bottom: 0.5rem;
      }

      &-option {
        padding: 0.5rem 0.75rem;
        font-size: 0.875rem;
        color: #000000;
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
          background: #f8f8f8;
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }

  &__loading {
    flex: 0 0 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.25rem;
    color: #252525;
  }

  &__content {
    flex: 1 1 auto;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 0.125rem;
      height: 0.125rem;
      display: block;
      background-color: #ececec;
      appearance: none;
      border-radius: 0.3125rem;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #252525;
      border-radius: 0.3125rem;
    }

    &-sizing {
      padding: 2rem 1.25rem 0;

      @media screen and (min-width: 64em) {
        padding: 2rem 2.5rem 0;
      }

      p {
        display: none;
      }
    }
  }

  &__content-stock-table {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  &__table-header {
    display: flex;
    position: sticky;
    top: 0;
    background-color: #f8f8f8;
    z-index: 1;
    padding: 0 1.25rem 0 1.25rem;

    @media screen and (min-width: 64em) {
      padding: 0 1.25rem 0 2.5rem;
    }
  }

  &__header-cell {
    padding-block: 1rem;
    padding-inline: 0.5rem;
    border: none;

    &:first-child {
      //padding-left: 2.5rem;
      flex: 1;
    }

    &:last-child {
      //padding-right: 2.5rem;
    }

    &:not(:first-child) {
      text-align: center;
      white-space: nowrap;
      min-width: 2rem;

      @media screen and (min-width: 64em) {
        min-width: 3rem;
      }
    }
  }

  &__table-body {
    display: flex;
    flex-direction: column;
    padding: 0 1.25rem 0 1.25rem;

    @media screen and (min-width: 64em) {
      padding: 0 1.25rem 0 2.5rem;
    }
  }

  &__table-row {
    display: flex;
    flex-direction: column;
    border-bottom: thin solid #ececec;
  }

  &__table-row-container {
    display: flex;
    padding: 0.5rem 0;
  }

  &__table-cell {
    padding-block: 1rem;
    padding-inline: 0.5rem;
    border: none;

    &--store {
      flex: 1;
      padding-left: 0.5rem;
      display: flex;
      flex-direction: column;

      span:first-child {
        grid-column: 1 / 3;
      }
    }

    &:last-child {
      //padding-right: 2.5rem;
    }

    &:not(.inventory__table-cell--store) {
      text-align: center;
      white-space: nowrap;
      min-width: 2rem;

      @media screen and (min-width: 64em) {
        min-width: 3rem;
      }
    }
  }

  &__outlet-info-row {
    width: 100%;
  }

  &__outlet {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    &-name {
      font-size: 1rem;
    }

    &-details {
      display: flex;
      align-items: center;
      gap: 0.25rem;
    }

    &-phone {
      font-size: 0.75rem;
      line-height: 0.75rem;
      text-decoration: underline;
      display: flex;
      align-items: flex-end;
      gap: 0.25rem;

      svg {
        height: 12px;
        width: 12px;
      }
    }

    &-info {
      display: grid;
      grid-template-columns: 3fr 2fr;
      grid-template-rows: auto auto;
      grid-gap: 1rem;
      padding: 1rem 0rem 1rem 0.5rem;
    }

    &-address {
      grid-column: 1 / 2;
      grid-row: 1 / 2;

      font-size: 0.75rem;

      @media screen and (min-width: 64em) {
        font-size: 0.875rem;
      }
    }

    &-hours {
      grid-column: 1 / 2;
      grid-row: 2 / 3;

      font-size: 0.75rem;

      @media screen and (min-width: 64em) {
        font-size: 0.875rem;
      }
    }

    &-page {
      grid-column: 2 / 3;
      grid-row: 2 / 3;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;

      a {
        padding: 0.5rem 1rem;
        border: solid 1px #000000;
      }
    }

    &-toggle {
      border: none;
      background: none;
      text-decoration: underline;
      font-size: 0.75rem;
      line-height: 0.75rem;
      display: flex;
      align-items: center;
      gap: 0.25rem;

      svg {
        height: 8px;
      }

      &.active {
        svg {
          transform: rotate(45deg);
        }
      }
    }
  }

  &__footer {
    flex: 0 0 auto;
    margin-top: auto;

    &-chat-wrapper {
      margin: 0 2.5rem 1rem;
    }

    &-chat-wrapper.noMargin {
      margin-bottom: 0;
    }

    &-chat {
      width: 100%;
      margin-top: 1.25rem;
      margin-bottom: 0.75rem;
      font-size: 0.9375rem;
      text-transform: uppercase;
    }

    &-toggle {
      display: flex;
      justify-content: space-around;
      border-top: solid 1px #252525;

      button {
        padding-block: 1.25rem;
        padding-inline: 2rem;
        text-transform: uppercase;
        font-size: 0.9375rem;
        color: #252525;
        background: transparent;
        border: none;
        flex: 0 0 50%;

        &:first-child {
          border-right: solid 1px #252525;
        }

        &:not(.active) {
          color: #9d9d9d;
        }
      }
    }
  }

  .in-stock,
  .nearly-gone,
  .out-of-stock {
    background-size: 1.15rem;
    background-position: center;
    background-repeat: no-repeat;
  }

  .in-stock {
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='10' cy='10.5' r='5' fill='%23009E60'/%3E%3C/svg%3E%0A");
  }

  .nearly-gone {
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='10' cy='10.5' r='5' fill='%23F6D177'/%3E%3C/svg%3E%0A");
  }

  .out-of-stock {
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m6 6.5 8 8m-8 0 8-8' stroke='%239D9D9D' stroke-width='2'/%3E%3C/svg%3E");
  }
}

.drawer-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.35);
  opacity: 0;
  z-index: 1000;
  transition: opacity 0.3s ease;
  pointer-events: none;

  &.active {
    opacity: 1;
    pointer-events: auto;
  }
}
</style>
